import React from "react";

const QuizSuccessIcon = () => {
  return (
    <svg
      width="300"
      height="300"
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2005_302)">
        <rect width="300" height="300" fill="white" />
        <mask
          id="mask0_2005_302"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="300"
          height="300"
        >
          <path d="M300 0H0V300H300V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2005_302)">
          <mask
            id="mask1_2005_302"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="17"
            y="22"
            width="266"
            height="255"
          >
            <path
              d="M17.5088 22.0352H282.215V276.34H17.5088V22.0352Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_2005_302)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M204.809 45.2298C204.19 45.7635 203.828 46.5419 203.819 47.3629C203.809 48.184 204.152 48.9666 204.759 49.5078L204.785 49.5293L208.585 52.8652L204.289 55.5689L204.264 55.5904C203.014 56.438 202.642 58.1296 203.421 59.4227C204.201 60.7158 205.853 61.149 207.165 60.4042L207.19 60.3827L207.26 60.3225L211.506 57.7229L212.641 62.4501L212.692 62.6844L212.703 62.7188C213.062 64.2322 214.564 65.16 216.062 64.7942C217.561 64.4284 218.493 62.9068 218.147 61.3902L218.135 61.3557L217.011 56.3856L221.693 56.7187L222.043 56.7466L222.081 56.7509C223.586 56.8178 224.88 55.6634 225.005 54.1417C225.13 52.6201 224.041 51.2796 222.544 51.1119L222.506 51.1075L217.484 50.687L219.243 46.3549L219.411 45.9507L219.431 45.9336C219.962 44.505 219.283 42.9142 217.895 42.3345C216.507 41.7548 214.909 42.3943 214.278 43.7814L214.258 43.7985L214.254 43.8027L212.278 48.512L208.506 45.281L208.437 45.2188L208.41 45.1972C207.367 44.3197 205.847 44.3333 204.809 45.2298Z"
              fill="#E40891"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M63.7195 204.25C63.3321 204.545 63.0902 204.996 63.0568 205.486C63.0233 205.977 63.2015 206.458 63.5451 206.805L63.5602 206.818L65.7144 208.959L63.0606 210.408L63.045 210.42C62.2708 210.878 61.992 211.875 62.4133 212.678C62.8345 213.481 63.8056 213.804 64.6132 213.409L64.6288 213.398L64.6724 213.364L67.2928 211.975L67.8104 214.844L67.8327 214.986L67.8385 215.007C68.0014 215.926 68.8656 216.538 69.7718 216.378C70.6779 216.217 71.285 215.344 71.1299 214.424L71.1241 214.403L70.6213 211.39L73.4024 211.77L73.6102 211.8L73.6327 211.805C74.5284 211.903 75.339 211.263 75.4649 210.359C75.5907 209.454 74.9864 208.611 74.099 208.453L74.0766 208.449L71.0957 208.003L72.2908 205.482L72.4044 205.247L72.4168 205.237C72.7817 204.404 72.4305 203.427 71.6222 203.027C70.8139 202.627 69.8388 202.947 69.4161 203.752L69.4037 203.761L69.4006 203.763L68.0638 206.501L65.9228 204.424L65.8834 204.384L65.8682 204.37C65.2758 203.805 64.3687 203.755 63.7195 204.25Z"
              fill="#E40891"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M47.2256 132.697C47.9117 132.697 48.4417 133.249 48.4417 133.963C48.4417 134.676 47.9117 135.228 47.2256 135.228C46.5395 135.228 46.0094 134.676 46.0094 133.963C46.0094 133.249 46.5395 132.697 47.2256 132.697ZM47.2256 130.167C45.225 130.167 43.5771 131.881 43.5771 133.963C43.5771 136.044 45.225 137.758 47.2256 137.758C49.2262 137.758 50.874 136.044 50.874 133.963C50.874 131.881 49.2262 130.167 47.2256 130.167Z"
              fill="#1D1E9D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M241.944 133.729C242.977 133.729 243.776 134.56 243.776 135.635C243.776 136.711 242.977 137.541 241.944 137.541C240.91 137.541 240.111 136.711 240.111 135.635C240.111 134.56 240.91 133.729 241.944 133.729ZM241.944 129.917C238.93 129.917 236.447 132.499 236.447 135.635C236.447 138.771 238.93 141.353 241.944 141.353C244.958 141.353 247.441 138.771 247.441 135.635C247.441 132.499 244.958 129.917 241.944 129.917Z"
              fill="#1D1E9D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M214.167 234.235L212.096 231.752L214.492 229.599L216.569 232.088L214.167 234.235ZM213.838 239.389C214.374 239.42 214.901 239.233 215.307 238.868L220.827 233.919C221.687 233.146 221.781 231.799 221.038 230.906L216.266 225.185C215.521 224.294 214.22 224.197 213.358 224.967L207.838 229.915C206.978 230.688 206.884 232.036 207.627 232.929L212.399 238.649C212.763 239.087 213.281 239.354 213.838 239.389Z"
              fill="#1D1E9D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M84.6727 68.8214L87.1656 66.5446L89.4344 69.0662L86.9356 71.3482L84.6727 68.8214ZM79.3802 68.5827C79.3621 69.1587 79.5673 69.7197 79.9523 70.1466L85.1666 75.9556C85.9808 76.8602 87.3653 76.9314 88.2619 76.1147L94.0051 70.8692C94.8996 70.0501 94.9665 68.6534 94.1546 67.7466L88.9407 61.9376C88.1266 61.0329 86.7421 60.9617 85.8455 61.7784L80.1018 67.0239C79.6624 67.4234 79.4021 67.9856 79.3802 68.5827Z"
              fill="#1D1E9D"
            />
            <path
              d="M148.842 94.793C177.519 94.793 200.803 118.385 200.803 147.442C200.803 176.499 177.519 200.091 148.842 200.091C120.165 200.091 96.8813 176.499 96.8813 147.442C96.8813 118.385 120.165 94.793 148.842 94.793Z"
              fill="url(#paint0_linear_2005_302)"
            />
            <path
              d="M123.878 143.963L118.554 149.358L140.882 171.982L179.1 133.258L173.776 127.863L140.882 161.193L123.878 143.963Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2005_302"
          x1="96.7602"
          y1="146.788"
          x2="200.927"
          y2="147.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E40891" />
          <stop offset="1" stopColor="#1D1E9D" />
        </linearGradient>
        <clipPath id="clip0_2005_302">
          <rect width="300" height="300" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QuizSuccessIcon;
